import { SkeletonWoo } from '@/components/skeleton/skeleton.woo';
import { type UpdateProfileProps } from '../-model/props';
import { Button, cn, If, useI18n, widgets } from '@nosinovacao/nosid-mfe-common';

export function TvProfileUpdateWooLoading({ isKidsProfile, hasPin }: Readonly<UpdateProfileProps>) {
  const { t } = useI18n();
  return (
    <div className="flex size-full flex-col items-center gap-4 overflow-y-auto px-1">
      <SkeletonWoo loading className="size-24 rounded-full" />
      <div className="grid w-full gap-6">
        <SkeletonWoo loading className="h-[74px] w-full" />
        <If condition={isKidsProfile}>
          <div className="mt-8 grid gap-2">
            <SkeletonWoo
              loading
              className="h-[74px] w-full rounded"
              count={widgets.AgeRatings.length}
            />
          </div>
        </If>
        <If condition={!isKidsProfile}>
          <SkeletonWoo loading className={cn('w-full', hasPin ? 'h-[249px]' : 'h-14')} />
        </If>
      </div>
      <div className="sticky bottom-0 mt-auto w-full bg-nos-neutral-0 pt-8 max-tablet:grid max-tablet:pb-8">
        <Button data-tid="button-submit-profile" skin="woo" disabled>
          {t('TvProfiles.CreateProfile.Submit')}
        </Button>
      </div>
    </div>
  );
}
